/**
 * @generated SignedSource<<3ca21c10fe78c84864036abfceadedac>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FilterBooleanOperator = "AND" | "NOT" | "OR" | "%future added value";
export type FilterElementInput = {
  multiple?: FilterBooleanOperationInput | null | undefined;
  single?: FilterValueInput | null | undefined;
};
export type FilterValueInput = {
  name: string;
  operator?: string | null | undefined;
  value?: string | null | undefined;
  values?: ReadonlyArray<string | null | undefined> | null | undefined;
};
export type FilterBooleanOperationInput = {
  operands: ReadonlyArray<FilterElementInput>;
  operator: FilterBooleanOperator;
};
export type EditDpcRootQuery$variables = {
  accountGroupFilterElement?: FilterElementInput | null | undefined;
  uuid: string;
};
export type EditDpcRootQuery$data = {
  readonly policyCollection: {
    readonly repositoryConfig: {
      readonly uuid: any;
    } | null | undefined;
    readonly " $fragmentSpreads": FragmentRefs<"UpsertDpcForm_policyCollection">;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"AdminPage_query" | "UpsertDpcForm_query">;
};
export type EditDpcRootQuery = {
  response: EditDpcRootQuery$data;
  variables: EditDpcRootQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "accountGroupFilterElement"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "uuid"
},
v2 = [
  {
    "kind": "Variable",
    "name": "uuid",
    "variableName": "uuid"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "uuid",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "roleAssignmentPrincipal",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "userPermissions",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "roleAssignmentTarget",
  "storageKey": null
},
v11 = {
  "kind": "Literal",
  "name": "first",
  "value": 1000
},
v12 = [
  (v11/*:: as any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "EditDpcRootQuery",
    "selections": [
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "AdminPage_query"
      },
      {
        "alias": null,
        "args": (v2/*:: as any*/),
        "concreteType": "PolicyCollection",
        "kind": "LinkedField",
        "name": "policyCollection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "RepositoryConfig",
            "kind": "LinkedField",
            "name": "repositoryConfig",
            "plural": false,
            "selections": [
              (v3/*:: as any*/)
            ],
            "storageKey": null
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "UpsertDpcForm_policyCollection"
          }
        ],
        "storageKey": null
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "UpsertDpcForm_query"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*:: as any*/),
      (v0/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "EditDpcRootQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "CurrentUser",
        "kind": "LinkedField",
        "name": "whoami",
        "plural": false,
        "selections": [
          (v4/*:: as any*/),
          (v5/*:: as any*/),
          (v6/*:: as any*/),
          (v7/*:: as any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v2/*:: as any*/),
        "concreteType": "PolicyCollection",
        "kind": "LinkedField",
        "name": "policyCollection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "RepositoryConfig",
            "kind": "LinkedField",
            "name": "repositoryConfig",
            "plural": false,
            "selections": [
              (v3/*:: as any*/),
              (v8/*:: as any*/)
            ],
            "storageKey": null
          },
          (v6/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "description",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "autoUpdate",
            "storageKey": null
          },
          (v3/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "RepositoryView",
            "kind": "LinkedField",
            "name": "repositoryView",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "branchName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "policyDirectories",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "policyFileSuffix",
                "storageKey": null
              },
              (v8/*:: as any*/)
            ],
            "storageKey": null
          },
          (v9/*:: as any*/),
          (v8/*:: as any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "kind": "InlineFragment",
                "selections": [
                  (v10/*:: as any*/),
                  {
                    "alias": null,
                    "args": (v12/*:: as any*/),
                    "concreteType": "RoleAssignmentConnection",
                    "kind": "LinkedField",
                    "name": "acl",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "RoleAssignmentEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "RoleAssignment",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v8/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Role",
                                "kind": "LinkedField",
                                "name": "role",
                                "plural": false,
                                "selections": [
                                  (v6/*:: as any*/),
                                  (v8/*:: as any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "principal",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "__typename",
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v8/*:: as any*/),
                                      (v5/*:: as any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "key",
                                        "storageKey": null
                                      },
                                      (v4/*:: as any*/),
                                      (v7/*:: as any*/)
                                    ],
                                    "type": "User",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v8/*:: as any*/),
                                      (v6/*:: as any*/),
                                      (v7/*:: as any*/)
                                    ],
                                    "type": "UserGroup",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v8/*:: as any*/)
                                    ],
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "acl(first:1000)"
                  }
                ],
                "type": "HasACL",
                "abstractKey": "__isHasACL"
              }
            ],
            "type": "Node",
            "abstractKey": "__isNode"
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v12/*:: as any*/),
        "concreteType": "UserGroupConnection",
        "kind": "LinkedField",
        "name": "userGroups",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "UserGroupEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "UserGroup",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v6/*:: as any*/),
                  (v7/*:: as any*/),
                  (v8/*:: as any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": "userGroups(first:1000)"
      },
      {
        "alias": null,
        "args": (v12/*:: as any*/),
        "concreteType": "UserConnection",
        "kind": "LinkedField",
        "name": "users",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "UserEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v4/*:: as any*/),
                  (v6/*:: as any*/),
                  (v7/*:: as any*/),
                  (v8/*:: as any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": "users(first:1000)"
      },
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "filterElement",
            "variableName": "accountGroupFilterElement"
          },
          (v11/*:: as any*/)
        ],
        "concreteType": "AccountGroupConnection",
        "kind": "LinkedField",
        "name": "accountGroups",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "AccountGroupEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "AccountGroup",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v6/*:: as any*/),
                  (v3/*:: as any*/),
                  (v10/*:: as any*/),
                  (v9/*:: as any*/),
                  (v8/*:: as any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "kind": "ClientExtension",
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "UrlConfig",
            "kind": "LinkedField",
            "name": "UrlConfig",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "docs",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "7c526d894bb946965f64f9b1cf346d41",
    "id": null,
    "metadata": {},
    "name": "EditDpcRootQuery",
    "operationKind": "query",
    "text": "query EditDpcRootQuery(\n  $uuid: String!\n  $accountGroupFilterElement: FilterElementInput\n) {\n  ...AdminPage_query\n  policyCollection(uuid: $uuid) {\n    repositoryConfig {\n      uuid\n      id\n    }\n    ...UpsertDpcForm_policyCollection\n    id\n  }\n  ...UpsertDpcForm_query\n}\n\nfragment ACLFormFields_acl on Node {\n  __isNode: __typename\n  ... on HasACL {\n    __isHasACL: __typename\n    roleAssignmentTarget\n    acl(first: 1000) {\n      edges {\n        node {\n          id\n          role {\n            name\n            id\n          }\n          principal {\n            __typename\n            ... on User {\n              id\n              displayName\n              key\n              email\n              roleAssignmentPrincipal\n            }\n            ... on UserGroup {\n              id\n              name\n              roleAssignmentPrincipal\n            }\n            ... on Node {\n              __isNode: __typename\n              id\n            }\n          }\n        }\n      }\n    }\n  }\n  id\n}\n\nfragment ACLFormFields_query on Query {\n  ...ACLPrincipalPicker_principals\n  whoami {\n    email\n    name\n    roleAssignmentPrincipal\n  }\n}\n\nfragment ACLPrincipalPicker_principals on Query {\n  userGroups(first: 1000) {\n    edges {\n      node {\n        name\n        roleAssignmentPrincipal\n        id\n      }\n    }\n  }\n  users(first: 1000) {\n    edges {\n      node {\n        email\n        name\n        roleAssignmentPrincipal\n        id\n      }\n    }\n  }\n}\n\nfragment AccountGroupPicker_accountGroups_1VU2v9 on Query {\n  accountGroups(filterElement: $accountGroupFilterElement, first: 1000) {\n    edges {\n      node {\n        name\n        uuid\n        roleAssignmentTarget\n        userPermissions\n        id\n      }\n    }\n  }\n}\n\nfragment AdminPage_query on Query {\n  ...PageWithBreadCrumbs_query\n}\n\nfragment BreadCrumbsHeader_query on Query {\n  whoami {\n    email\n    displayName\n  }\n}\n\nfragment PageWithBreadCrumbs_query on Query {\n  ...BreadCrumbsHeader_query\n}\n\nfragment UpsertDpcForm_policyCollection on PolicyCollection {\n  name\n  description\n  autoUpdate\n  uuid\n  repositoryView {\n    branchName\n    policyDirectories\n    policyFileSuffix\n    id\n  }\n  userPermissions\n  ...ACLFormFields_acl\n}\n\nfragment UpsertDpcForm_query on Query {\n  ...ACLFormFields_query\n  ...AccountGroupPicker_accountGroups_1VU2v9\n}\n"
  }
};
})();

(node as any).hash = "a1bdd5d7670fed4d81d8fe1665d777bc";

export default node;
